import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CandidateHub from "../../assets/icons/CandidateHub";
import LogoutIco from "../../assets/icons/LogoutIco";
import CommonButton from "../../component/Button";
import SnackBar from "../../component/SnackBar";
import { CommonGrid2 } from "../../modules/common-components/StyledComponents";
import DialogCandidateHub from "../../modules/jobs/jobs-candidate/components/DialogCandidateHub";
import {
  JobCreateFormikData,
  JobJobFormikData,
  JobJobSubmit,
  JobResumeDuplicate,
} from "../../redux/action/Job";
import {
  MinimizeIcon,
  PreviousPathName,
  SetLocalStorage,
} from "../../redux/action/Login";
import { ResumeIntelligenceSave } from "../../redux/action/ResumeIntelligence";
import { rebuildSourceFromFinalData } from "../../utils/constants";
import Sidebar from "./Components/Sidebar";

import ReportBugIco from "../../assets/icons/ReportBugIco";
import SupportIco from "../../assets/icons/SupportIco";
import ChatBotLabelText from "../../modules/chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../modules/chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../modules/chat-bot/style";
import FloatingFeedbackButton from "../../modules/feedback";
import { SupportCall, SupportGetCall } from "../../redux/action/ChatBot";
import { FeedBackButton } from "../../redux/action/Feedback";
import UsePreviousRoute from "../../utils/UsePreviousRoute";
import {
  AgencyPartner,
  DeliveryAgency,
  HiringTeam,
  JobSeeker,
  RecruitingAgency,
} from "./Components/MenuItem";
import ResumeIntelligenceToast, {
  SowEnrichToast,
  WorkFlowManagementToast,
} from "./Components/ToastMessage";
import Setting from "./settings";
import { StyleToastContainer } from "./style";
import NotificationDrawer from "../../modules/notification";

function PortalLayout() {
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const [open, setOpen] = useState({ open: true, chatBotIcon: false });
  const theme = useTheme();
  const notification_data = useSelector((state) => state.notification.count);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [expandedItems, setExpandedItems] = useState({});
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const SidebarItems =
    storageData?.agency_type === "Recruiting Agency"
      ? RecruitingAgency({ storageData, open: open.open })
      : storageData?.agency_type === "Delivery Agency"
      ? DeliveryAgency({ storageData, open: open.open })
      : storageData?.agency_type === "VMS"
      ? AgencyPartner({ storageData, open: open.open })
      : storageData?.agency_type === "Hiring Teams"
      ? HiringTeam({ storageData, open: open.open })
      : JobSeeker({ storageData, open: open.open });

  const [loading, setLoading] = useState({
    open: false,
    prevData: "",
    disabled: false,
    leaveLoading: false,
    saveLoading: false,
    duplicateLoading: false,
    replacedLoading: false,
    openDuplicate: false,
  });
  const [openNotification, setOpenNotification] = useState({ open: false });

  const [isBottomVisible, setIsBottomVisible] = useState(true);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [candidateHub, setCandidateHub] = useState({
    open: false,
    prevData: "",
    cancelLoading: false,
    disabled: false,
    yesLoading: false,
  });
  const [saveEditData, setSaveEditData] = React.useState({
    open: false,
    prevData: "",
    leaveLoading: false,
    disabled: false,
    saveLoading: false,
  });
  const [logout, setLogout] = useState({
    logoutLoading: false,
    open: false,
    disabled: false,
    noLoading: false,
  });
  const JobJobEditData = useSelector((state) => state.jobs.jobJobEditData);
  const localStorage_data = useSelector((state) => state.layout.localStorage);

  const CreateJobEditData = useSelector(
    (state) => state.jobs.jobCreateEditData
  );
  const sowEnrichData = useSelector((state) => state.sow.sowEnrich);
  const workFlowManagement = useSelector(
    (state) => state.jobs.workFlowManagement
  );

  const layout = useSelector((state) => state.layout.layout);
  const [chatBotData, setChatBotData] = useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubbleCondition: false,
    selectedValue: "Support",
    expandDrawer: false,
  });
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const buttonSupport = [
    {
      name: "Support",
      icon: <SupportIco />,
    },
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];
  const fullUrl = window.location.href;
  const checkPathLocation =
    !fullUrl.includes("jobs/jobs-view?") &&
    !location.pathname.includes("candidates/candidate-view") &&
    !location.pathname.includes("judica/judica-view") &&
    !location.pathname.includes("jobs/candidate/compare") &&
    !location.pathname.includes("sow-enrichment/create-enrich") &&
    !fullUrl.includes("sow-enrichment?value") &&
    !location.pathname.includes("/growth-agent") &&
    !location.pathname.includes("/recruiting-agent") &&
    !location.pathname.includes("/hiring-agent") &&
    !location.pathname.includes("/create-new-job") &&
    !location.pathname.includes("/enrich-job") &&
    !location.pathname.includes("/jobs/candidate/compare") &&
    !location.pathname.includes("/resume-intelligence/create-candidate-resume");

  const prevLocation = UsePreviousRoute();
  const [settingDialog, setSettingDialog] = useState({
    dialog: false,
    sidenav: true,
  });

  useEffect(() => {
    if (prevLocation) {
      dispatch(PreviousPathName(prevLocation));
    }
  });

  useEffect(() => {
    localStorage.setItem("Add To Job Pool", JSON.stringify([]));
    if (localStorageData === null) {
      navigate("auth/login");
    }
    dispatch(
      SetLocalStorage({
        data: storageData,
      })
    );
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const toggleDrawer = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev.open;
      const check = condition === "chatbot";
      // dispatch(
      //   MinimizeIcon(
      //     check ? !newState : newState,
      //     check ? !prev.chatBotIcon : prev.open
      //   )
      // );

      return {
        open: check ? !newState : newState,
        chatBotIcon: check ? !prev.chatBotIcon : prev.chatBotIcon,
      };
    });
  };

  useEffect(() => {
    if (
      layout.jobRight &&
      (location.pathname.includes("/about") ||
        location.pathname.includes("/home"))
    ) {
      setOpen((prev) => ({
        open: prev.open,
        chatBotIcon: layout.jobRight,
      }));
    }
  }, [location, layout]);

  useEffect(() => {
    if (!lgUp) setOpen({ open: false, chatBotIcon: false });
  }, [lgUp]);

  const handleNavigation = async (path, condition) => {
    const createCondition =
      (fullUrl.includes("enrich-job?value=") ||
        fullUrl.includes("create-new-job?value")) &&
      JSON.stringify(CreateJobEditData.formikData) !==
        JSON.stringify(CreateJobEditData.jobData);

    // if (
    //   location.pathname + location.search ===
    //   "/resume-intelligence/create-candidate-resume?resume=parse"
    // ) {
    //   setLoading((prev) => ({
    //     ...prev,
    //     open: !resumeIntelligence?.data?.is_duplicate_present,
    //     openDuplicate: resumeIntelligence?.data?.is_duplicate_present,
    //     prevData: path,
    //     createCondition: false,
    //   }));
    // } else

    if (
      fullUrl.includes("resume-intelligence/create-candidate-resume") &&
      (location.search === "?value=2" || location.search === "?resume=parse") &&
      resumeIntelligence?.data?.need_review?.length !== 0
    ) {
      setCandidateHub((prev) => ({
        ...prev,
        open: true,
        prevData: path,
      }));
    } else if (
      ((fullUrl.includes("jobs/jobs-view?") ||
        location.pathname.includes("judica/judica-view")) &&
        JSON.stringify(JobJobEditData.formikData) !==
          JSON.stringify(JobJobEditData.jobData)) ||
      createCondition
    ) {
      setSaveEditData((prev) => ({
        ...prev,
        open: true,
        prevData: path,
        createCondition: createCondition,
      }));
    } else if (path) {
      if (condition === "setting") {
        setSettingDialog((prev) => ({
          ...prev,
          dialog: true,
        }));
      } else if (path === "feedback") {
        dispatch(FeedBackButton(true));
      } else if (path === true) {
        setOpen({ open: true, chatBotIcon: false });
        // setOpen((prev) => {
        //   dispatch(MinimizeIcon(true, false));
        //   return { open: true, chatBotIcon: false };
        // });
      } else {
        setOpen((prev) => {
          dispatch(MinimizeIcon(true, false));
          return { open: true, chatBotIcon: false };
        });
        navigate(path);
      }
    }
  };

  const handleSaveCandidate = () => {
    setLoading((prev) => ({
      ...prev,
      open: false,
      prevData: "",
      disabled: false,
      leaveLoading: false,
      saveLoading: false,
      duplicateLoading: false,
      replacedLoading: false,
      openDuplicate: false,
    }));
  };

  const resumeIntelligence = useSelector(
    (state) => state.resumeIntelligence.resumeIntelligenceUpload
  );
  const jobCandidateResume = useSelector(
    (state) => state.jobs.jobCandidateResume
  );

  useEffect(() => {
    if (
      Object.keys(resumeIntelligence.file).length !== 0
      // &&
      // !location.pathname.includes("resume-intelligence/create-candidate-resume")
    ) {
      toast.dismiss("resume-intelligence-toast");
      toast(
        <ResumeIntelligenceToast
          resumeIntelligence={resumeIntelligence?.file}
          title="Resume Intelligence"
        />,
        {
          toastId: "resume-intelligence-toast",
          position: "bottom-left",
          hideProgressBar: true,
        }
      );
    }
  }, [resumeIntelligence]);

  const addToJobPoolData = useSelector((state) => state.candidate.addToJobPool);

  useEffect(() => {
    if (addToJobPoolData?.data?.length !== 0) {
      toast.dismiss("add-to-job-pool-toast");
      toast(
        <ResumeIntelligenceToast
          resumeIntelligence={addToJobPoolData?.data}
          title="Add to Job pool"
        />,
        {
          toastId: "add-to-job-pool-toast",
          position: "bottom-left",
          hideProgressBar: true,
        }
      );
    }
  }, [addToJobPoolData]);

  useEffect(() => {
    if (
      Object.keys(jobCandidateResume.file).length !== 0
      // &&
      // !location.pathname.includes("resume-intelligence/create-candidate-resume")
    ) {
      toast.dismiss("job-resume-candidate");
      toast(
        <ResumeIntelligenceToast
          resumeIntelligence={jobCandidateResume?.file}
          title="Job Candidate Resume"
        />,
        {
          toastId: "job-resume-candidate",
          position: "bottom-left",
          hideProgressBar: true,
        }
      );
    }
  }, [jobCandidateResume]);

  useEffect(() => {
    if (workFlowManagement.files && workFlowManagement.files.length !== 0) {
      if (toast.isActive("work-flow-management-toast")) {
        toast.update("work-flow-management-toast", {
          render: (
            <WorkFlowManagementToast
              files={workFlowManagement?.files}
              title="Work Flow Management"
            />
          ),
          position: "bottom-left",
          hideProgressBar: true,
        });
      } else {
        toast(
          <WorkFlowManagementToast
            files={workFlowManagement?.files}
            title="Work Flow Management"
          />,
          {
            toastId: "work-flow-management-toast",
            position: "bottom-left",
            hideProgressBar: true,
          }
        );
      }
    }
  }, [workFlowManagement]);

  useEffect(() => {
    if (
      Object.keys(sowEnrichData.files).length !== 0 &&
      (sowEnrichData.status === "sucsess" ||
        sowEnrichData.status === "Inprogress")
    ) {
      toast.dismiss("sow-enrich-toast");
      toast(
        <SowEnrichToast
          resumeIntelligence={sowEnrichData?.files}
          title="Sow Enrich"
        />,
        {
          toastId: "sow-enrich-toast",
          position: "bottom-left",
          hideProgressBar: true,
        }
      );
    }
  }, [sowEnrichData]);

  const handleSave = async () => {
    setLoading((prev) => ({ ...prev, disabled: true, saveLoading: true }));
    try {
      let params = {
        resume_id: resumeIntelligence.data.id,
      };
      const data = await dispatch(ResumeIntelligenceSave(params));
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      setLoading((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        open: false,
      }));
      navigate(loading.prevData);
    } catch (error) {
      setLoading((prev) => ({ ...prev, disabled: false, saveLoading: false }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
    }
  };

  const handleJobLeave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      leaveLoading: true,
    }));
    if (saveEditData?.createCondition) {
      await dispatch(
        JobCreateFormikData(
          CreateJobEditData.jobData,
          CreateJobEditData.jobData
        )
      );
    } else {
      await dispatch(
        JobJobFormikData(JobJobEditData.jobData, JobJobEditData.jobData)
      );
    }
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        leaveLoading: false,
        open: false,
      }));
      navigate(saveEditData.prevData);
    } catch (error) {}
  };

  const handleJobClose = () => {
    setSaveEditData((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleJobSave = async () => {
    setSaveEditData((prev) => ({
      ...prev,
      disabled: true,
      saveLoading: true,
    }));

    const values = saveEditData?.createCondition
      ? CreateJobEditData.jobData
      : JobJobEditData.jobData;
    const result = (valueData) => {
      if (!valueData) return [];

      const processedData = valueData.reduce((acc, { name, content }) => {
        const existing = acc.find((item) => item.name === name);
        if (existing) {
          existing.content.push(content);
        } else {
          acc.push({ name, content: [content] });
        }
        return acc;
      }, []);

      const extracted = processedData.find((item) => item.name === "extracted");
      const inferred = processedData.find((item) => item.name === "inferred");
      const userAdded = processedData.find(
        (item) => item.name === "user_added"
      );

      const resultData = [];
      if (!extracted) {
        resultData.push({ name: "extracted", content: [] });
      } else {
        resultData.push(extracted);
      }
      if (!inferred) {
        resultData.push({ name: "inferred", content: [] });
      } else {
        resultData.push(inferred);
      }
      const otherData = processedData.filter(
        (item) =>
          item.name !== "extracted" &&
          item.name !== "inferred" &&
          item.name !== "user_added"
      );
      resultData.push(...otherData);
      if (!userAdded) {
        resultData.push({ name: "user_added", content: [] });
      } else {
        resultData.push(userAdded);
      }
      return resultData;
    };

    const data = {
      ...values,
      employer_targets: result(values.employer_targets),
      certificates: result(values.certificates),
      languages: result(values.languages),
      shift: result(values.shift),
      visa_status: rebuildSourceFromFinalData(values.visa_status),
      location_targets: result(values.location_targets),
      high_priority: values.skillData.high_priority,
      low_priority: values.skillData.low_priority,
      medium_priority: values.skillData.medium_priority,
      recommended: values.skillData.recommended,
      industry: rebuildSourceFromFinalData(values.industry),
    };

    

    try {
      if (saveEditData?.createCondition) {
        dispatch(JobCreateFormikData(values, values));
      } else {
        dispatch(JobJobFormikData(values, values));
      }
      const jobEdit = await JobJobSubmit(values.id, data);

      setSnackbarState({
        open: true,
        severity: "success",
        message: jobEdit.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
        open: false,
      }));
      navigate(saveEditData.prevData);
    } catch (error) {
      if (saveEditData?.createCondition) {
        dispatch(JobCreateFormikData(CreateJobEditData.jobData, values));
      } else {
        dispatch(JobJobFormikData(JobJobEditData.jobData, values));
      }
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setSaveEditData((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
      }));
    }
  };

  const handleSaveLeave = async (action) => {
    let params = {
      action: action,
      resume_id: resumeIntelligence?.data.id,
    };
    setLoading((prev) => ({ ...prev, disabled: true, leaveLoading: true }));
    try {
      const data = await JobResumeDuplicate(params);
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      handleSaveCandidate();
      navigate(loading.prevData);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setLoading((prev) => ({
        ...prev,
        leaveLoading: false,
        disabled: false,
      }));
    }
  };

  const Footer = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        color="#344054"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        border={"#D0D5DD"}
        onClick={loading.open ? () => handleSaveLeave("leave") : handleJobLeave}
        disabled={loading.open ? loading.disabled : saveEditData.disabled}
        loading={
          loading.open ? loading.leaveLoading : saveEditData.leaveLoading
        }
      />
      <CommonButton
        value={"Save"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={loading.open ? loading.disabled : saveEditData.disabled}
        loading={loading.open ? loading.saveLoading : saveEditData.saveLoading}
        onClick={loading.open ? handleSave : handleJobSave}
      />
    </CommonGrid2>
  );

  const handleCandidateHubClose = () => {
    setCandidateHub({
      open: false,
      prevData: "",
      cancelLoading: false,
      disabled: false,
      yesLoading: false,
    });
  };

  const handleCandidateHubCancel = () => {
    setCandidateHub((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      handleCandidateHubClose();
    }, 1000);
  };

  const handleCandidateHubSave = () => {
    setCandidateHub((prev) => ({
      ...prev,
      disabled: true,
      yesLoading: true,
    }));
    setTimeout(() => {
      navigate(candidateHub.prevData);
      handleCandidateHubClose();
    }, 1000);
  };

  const CandidateFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"Cancel"}
        variant="outlined"
        color="#344054"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        border={"#D0D5DD"}
        onClick={handleCandidateHubCancel}
        disabled={candidateHub.disabled}
        loading={candidateHub.cancelLoading}
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={candidateHub.disabled}
        loading={candidateHub.yesLoading}
        onClick={handleCandidateHubSave}
      />
    </CommonGrid2>
  );

  const FooterViewResume = () => (
    <CommonGrid2>
      <CommonGrid2 display={"flex"} gap={"1rem"}>
        <CommonButton
          value={"Duplicate"}
          variant="outlined"
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          color="#344054"
          border="#D0D5DD"
          disabled={loading.disabled}
          loading={loading.duplicateLoading}
          onClick={() => handleDuplicate("duplicate")}
        />
        <CommonButton
          value={"Replace Existing"}
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={loading.disabled}
          loading={loading.replacedLoading}
          onClick={() => handleDuplicate("replaced")}
        />
      </CommonGrid2>
      <CommonButton
        value={"Leave"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={loading.disabled}
        loading={loading.leaveLoading}
        onClick={() => handleDuplicate("leave")}
      />
    </CommonGrid2>
  );

  const FooterLogout = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={logout.disabled}
        loading={logout.noLoading}
        onClick={() => {
          setLogout((prev) => ({
            ...prev,
            disabled: true,
            noLoading: true,
          }));
          setTimeout(() => {
            handleLogout();
          }, 1000);
        }}
      />
      <CommonButton
        value={"Logout"}
        width={"100%"}
        variant="contained"
        color="white"
        background="#D92D20"
        padding={"10px"}
        marginTop={"1rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={logout.disabled}
        loading={logout.logoutLoading}
        onClick={() => {
          setLogout((prev) => ({
            ...prev,
            logoutLoading: true,
            disabled: true,
          }));
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            dispatch({ type: "RESET_ALL" });
            navigate("/auth/login");
          }, 1000);
        }}
      />
    </CommonGrid2>
  );

  const handleDuplicate = async (action) => {
    let params = {
      action: action,
      resume_id: resumeIntelligence?.data.id,
    };
    setLoading((prev) => ({
      ...prev,
      disabled: true,
      duplicateLoading: action === "duplicate" ? true : false,
      replacedLoading: action === "replaced" ? true : false,
      leaveLoading: action === "leave" ? true : false,
    }));
    try {
      const data = await JobResumeDuplicate(params);

      setSnackbarState({
        open: true,
        severity: "success",
        message: data?.message,
      });
      setLoading((prev) => ({
        ...prev,
        openDuplicate: false,
        disabled: false,
        duplicateLoading: false,
        replacedLoading: false,
      }));
      navigate(loading.prevData);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setLoading((prev) => ({
        ...prev,
        disabled: false,
        duplicateLoading: false,
        replacedLoading: false,
      }));
    }
  };

  const handleLogout = () => {
    setLogout({
      noLoading: false,
      open: false,
      logoutLoading: false,
      disabled: false,
    });
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;

    let payload = {
      query: chatBotData.value,
      filter_criteria: {
        type: "user_manuals",
        user_id: localStorageData?.user_id,
      },
    };

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],
      loader: true,
      value: "",
    }));

    try {
      const data = await SupportCall(payload);

      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],
        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],
        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  //settingDrawer
  const handleSettingToggleDrawer = () => {
    setSettingDialog((prev) => ({
      ...prev,
      sidenav: !prev.sidenav,
    }));
  };

  const handleApplicationLogout = () => {
    setLogout((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleSettingDialogClose = () => {
    setSettingDialog((prev) => ({
      ...prev,
      dialog: false,
    }));
  };

  const handleExpandToggle = (index) => {
    // setExpandedItems((prev) => ({
    //   ...prev,
    //   [index]: !prev[index],
    // }));
    setExpandedItems((prev) => {
      const newState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return { ...newState, [index]: !prev[index] };
    });
  };
  const handleToggleDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Support",
    }));
    setOpen((prev) => ({ open: !prev.open, chatBotIcon: prev.chatBotIcon }));
  };

  useEffect(() => {
    const setExpandedFromPath = (items) => {
      const state = {};
      const expand = (items) => {
        for (const [index, item] of items.entries()) {
          if (item.children) {
            const isChildMatch = item.children.some((child) =>
              window.location.href.includes(child.path)
            );
            state[index] = isChildMatch;
            if (isChildMatch) expand(item.children);
          }
        }
      };
      expand(items);
      return state;
    };
    const newExpanded = setExpandedFromPath(SidebarItems);
    setExpandedItems(newExpanded);
  }, [open.open === true, location.pathname]);

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  const handleNotification = () => {
    setOpenNotification((prev) => ({
      ...prev,
      open: true,
    }));
  };
  return (
    <Box display={"flex"} minHeight={"100vh"} overflow={"hidden"}>
      <Box
        flexShrink={0}
        width={!lgUp ? theme.spacing(8) : open.open ? 290 : theme.spacing(8)}
        borderRight={"1px solid #EAECF0"}
        height={"100vh"}
        position={"sticky"}
        top={0}
        sx={{
          transition: theme.transitions.create("width", {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        <Sidebar
          open={open.open}
          handleNavigation={handleNavigation}
          lgUp={lgUp}
          theme={theme}
          expandedItems={expandedItems}
          handleExpandToggle={handleExpandToggle}
          handleToggleDrawer={handleToggleDrawer}
          fullUrl={fullUrl}
          location={location}
          storageData={storageData}
          SidebarItems={SidebarItems}
          toggleDrawer={toggleDrawer}
          localStorage_data={localStorage_data}
          handleNotification={handleNotification}
          notification_data={notification_data}
        />
      </Box>
      <CustomDiv
        background="#F6F8FB"
        maxHeight={"100vh"}
        overflowY="auto"
        display="flex"
        width="100%"
      >
        <Box
          flex={1}
          height={"max-content"}
          width={
            checkPathLocation
              ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
              : "100%"
          }
          // sx={{
          //   // overflowY: "auto",
          //   transition: theme.transitions.create(["max-width", "margin"], {
          //     duration: theme.transitions.duration.standard,
          //   }),
          // }}
        >
          <Outlet />
          <FloatingFeedbackButton />
        </Box>
        {checkPathLocation && (
          <CommonGrid2
            sx={{
              transition: theme.transitions.create(["width"], {
                duration: theme.transitions.duration.short,
                easing: theme.transitions.easing.easeInOut,
              }),
            }}
            width={
              open.chatBotIcon
                ? chatBotData.expandDrawer
                  ? "450px"
                  : "350px"
                : "0px"
            }
            border={"1px solid rgba(0, 0, 0, 0.12)"}
            background="#fff"
            top={"0px"}
            position={"sticky"}
            right={"0"}
            height={"100%"}
            overflowY={"auto"}
            scrollStyle
            scrollBar="5px"
          >
            <CommonGrid2
              padding={"0rem 1rem 8px"}
              height={"100%"}
              justifyContent={"space-between"}
              display={"flex"}
              flexDirection={"column"}
            >
              <SideBarChatBot
                handleToggleDrawer={() => toggleDrawer("chatbot")}
                jobId={""}
                // height={minimizeScreen}
                chatBotData={chatBotData}
                // handleChatBotFetchData={handleChatBotFetchData}
                handleSendMessage={handleSendMessage}
                handleChatBotChange={handleChatBotChange}
                isBottomVisible={isBottomVisible}
                setIsBottomVisible={setIsBottomVisible}
                handleUpArrow={handleUpArrow}
                userName={localStorageData?.username}
                buttonSupport={buttonSupport}
                handleButtonSupport={handleButtonSupport}
                handleExpandDrawer={handleExpandDrawer}
              />
            </CommonGrid2>
          </CommonGrid2>
        )}
      </CustomDiv>
      <DialogCandidateHub
        open={loading.open}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Save to Candidate Hub?"
        handleClose={handleSaveCandidate}
        titlepadding={"0px 0px 16px"}
        footer={<Footer />}
        content={
          "You have unsaved changes. If you leave this page, your changes will be lost. Are you sure you want to proceed?"
        }
      />
      <DialogCandidateHub
        open={saveEditData.open}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Save to JEM"
        titlepadding={"0px 0px 16px"}
        handleClose={handleJobClose}
        footer={<Footer />}
        content={
          "You have unsaved changes. If you leave this page, your changes will be lost. Are you sure you want to proceed?"
        }
      />
      <DialogCandidateHub
        open={candidateHub.open}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        title="Do you want to leave ?"
        titlepadding={"0px 0px 16px"}
        handleClose={handleCandidateHubClose}
        footer={<CandidateFooter />}
        content={"The records that needs review will be moved to Drafts."}
      />
      <DialogCandidateHub
        open={loading.openDuplicate}
        handleClose={handleSaveCandidate}
        icon={<CandidateHub margin={"10px 0px 0px 10px"} />}
        footer={<FooterViewResume />}
        title="Candidate Already Exists"
        titlepadding={"0px 0px 16px"}
        content={
          <>
            You are about to save a candidate under the name{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeIntelligence?.data?.personal_details?.candidate_name}
            </strong>{" "}
            and the role{" "}
            <strong style={{ fontWeight: 700 }}>
              {resumeIntelligence?.data?.personal_details?.inferred_title}
            </strong>{" "}
            in the Candidate Hub.
          </>
        }
      />
      {checkPathLocation && !open.chatBotIcon && (
        <ChatBotLabelText
          chatBotData={chatBotData}
          handleToggleDrawer={() => toggleDrawer("chatbot")}
        />
      )}
      <DialogCandidateHub
        open={logout.open}
        centerIcon={<LogoutIco />}
        handleClose={handleLogout}
        footer={<FooterLogout />}
        title="Are you want to logout?"
        titlepadding={"16px 0px 16px"}
      />
      <StyleToastContainer
        // stacked={true}
        position="bottom-left"
        // autoClose={5000}
        hideProgressBar={true}
      />
      <Setting
        settingDialog={settingDialog}
        lgUp={lgUp}
        theme={theme}
        handleSettingToggleDrawer={handleSettingToggleDrawer}
        handleApplicationLogout={handleApplicationLogout}
        handleSettingDialogClose={handleSettingDialogClose}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <NotificationDrawer
        open={openNotification.open}
        onClose={() => setOpenNotification({ open: false })}
        // data={notificationData}
      />
    </Box>
  );
}

export default PortalLayout;
